import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { ProtectLightComponent } from './protect-light/protect-light.component';
import { MainInputFormComponent } from './main-input-form/main-input-form.component';
import { ProtectPlusComponent } from './protect-plus/protect-plus.component';
import { ProtectPremiumComponent } from './protect-premium/protect-premium.component';
import { ProtectCustomComponent } from './protect-custom/protect-custom.component';
import { PaymentFormComponent } from './payment-form/payment-form.component';
import { CustomModalFormComponent } from './custom-modal-form/custom-modal-form.component';
import {NgxPageScrollModule} from 'ngx-page-scroll';
import { NdbxModule } from './modules/ndbx/ndbx.module';



@NgModule({
  declarations: [
    AppComponent,
    ProtectLightComponent,
    MainInputFormComponent,
    ProtectPlusComponent,
    ProtectPremiumComponent,
    ProtectCustomComponent,
    PaymentFormComponent,
    CustomModalFormComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgxPageScrollModule,
    NdbxModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
